module.exports = "#sidenav {\n    min-height: calc(98vh - 80px);\n    background-color: #183b78;\n}\n\n* {\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n}\n\n@media (max-width: 768px) {\n    #sidenav {\n      display: none;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/gerenciador.component.css
// module id = ./src/app/gerenciador/gerenciador.component.css
// module chunks = main